/* eslint-disable */
export const langZH = {
  'nav': {
    'hello': '您好，欢迎光临过来玩网！',
    'classification': '全部分类',
    'login': '登录',
    'register': '注册',
    'personalCenter': '个人中心',
    'logOut': '退出登录',
    'shoppingCart': '购物车',
    'search': '输入你想查找的商家',
    'conNumber': '联系电话',
    'boss': '刘先生'
  },
  'aboutUs': {
    'companyProfile': '公司简介',
    'companyProfileOne': '遵化市博客旅游集散中心“过来玩”网站成立于2012年6月，注册资金1000万元。2015年5月，适应京津冀旅游协同发展和开发全域智慧旅游的形势需求。“过来玩”网站致力于智慧化景区、社区以及智慧化城市规划设计，旅游产品策划研发，旅游大数据，旅游活动组织和会展服务，是覆盖全国、具有浓郁地方特色，pc端、手机APP、微官网、小程序四网合一，集“吃、住、行、游、购、娱”为一体的智慧旅游网站。',
    'companyProfileTwo': '业务主要涵盖景区门票、智慧导览、分销、智慧住宿、智慧餐厅、地方特产、智慧停车、多机位直播、生活服务、大数据平台、自由行个性定制、进出口跨境网上商城交易的线上线下交易平台。',
    'companyHonor': '公司荣誉',
    'companyPartner': '公司合伙人',
    'companyPartnerOne': '“过来玩”多机位直播',
    'companyPartnerOneContent': '在线多机位直播，可录制直播，直播回放，直播视频下载',
    'companyPartnerTwo': '北京平谷区智慧旅游',
    'companyPartnerTwoContent': '全域休闲，畅游平谷。',
    'companyPartnerThree': '国际饭店',
    'companyPartnerThreeContent': '遵化国际饭店隶属遵化市政府，是集餐饮、住宿、购物、娱乐为一体的三星级旅游涉外饭店。',
    'companyPartnerFour': '花乡果巷景区',
    'companyPartnerFourContent': '花乡果巷，花海趣圈。',
    'companyPartnerFive': '金融街•汤泉宫温泉旅游度假村',
    'companyPartnerFiveContent': '以皇家温泉养生文化为核心，深入挖掘皇家温泉养生之道，注重汤泉温泉生态构建，弘扬健康温泉养生理念，精心打造中国皇家温泉养生文化旅游高端品牌',
    'companyPartnerSix': '任记农产品•非物质文化遗产',
    'companyPartnerSixContent': '非物质文化遗产。',
    'companyPartnerSeven': '万佛园4A级景区智慧导览',
    'companyPartnerSevenContent': '展示手绘地图，集语音、服务、景点介绍、线路一体的智慧化导游功能。',
    'companyPartnerEight': '兴隆山景区',
    'companyPartnerEightContent': '完整的自然生态系统、良好的自然生态气候，兴隆山是观光旅游，休闲旅游，生态旅游的极佳场所。',
    'joinUs': '加入我们',
    'joinUsOne': '招聘信息',
    'joinUsTwo': '找工作来这里',
    'joinUsThree': '过来玩团队等待您的加入',
    'joinUsFour': '查看详情',
    'contactInformation': '联系信息',
    'contactInformationOne': '联系电话：0315-6686299 / 0315-6681288',
    'contactInformationTwo': '邮箱：guolaiwan99@163.com',
    'contactInformationThree': '地址：中国·遵化万乘晟象大厦12层',
    'contactInformationFour': '想了解更多关于我们的信息 可以扫描下方二维码哟',
  }, 'personalCenter': {
    'personal': '个人中心',
    'personalInformation': '个人信息',
    'myOrder': '我的订单',
    'commonInformation': '常用信息',
    'myFocus': '我的关注',
    'AfterSalesService': '售后服务',
    'myAccount': '我的钱包',
    'guideCenter': '导游中心',
    'guideApplication': '导游申请',
    'myCollection': '我的收藏',
    'coupon': '优惠券',
    'Essentialinformation': '基本信息',
    'nickname': '昵称',
    'Pleasenickname': '请输入昵称',
    'username': '用户名',
    'enterusername': '请输入用户名',
    'Gender': '性别',
    'male': '男',
    'female': '女',
    'Submit': '提交',
    'Reset': '重置',
    'Myorder': '我的订单',
    'Noorderbeing': '暂时没有订单',
    'amount': '金额',
    'Commoditydiscount': '商品优惠',
    'Couponoffset': '优惠券抵',
    'status': '状态',
    'operation': '操作',
    'copewith': '应付',
    'Paid': '已支付',
    'Immediatepayment': '立即支付',
    'Onlinepayment': '线上支付',
    'orderId': '订单号',
    'orderDetail': '订单详情',
    'Topay': '去付款',
    'cancellationoforder': '取消订单',
    'Deleteorder': '删除订单',
    'Addshippingaddress': '添加收货地址',
    'Defaultaddress': '默认地址',
    'consignee': '收货人',
    'Consigneeinformation': '收货人信息',
    'Deliveryinformation': '配送信息',
    'Deliverymethod': '配送方式',
    'Pickitupatthestore': '到店自取',
    'Responsiblemerchants': '负责商家',
    'orderType': '订单类型',
    'remarks': '备注',
    'Paymentinformation': '付款信息',
    'paymentmethod': '付款方式',
    'orderTime': '下单时间',
    'Totalgoods': '商品总额',
    'Preferentialamount': '优惠金额',
    'Amountpayable': '应支付金额',
    'Orderstatus': '订单状态',
    'Applyforrefund': '申请退款',
    'Confirmreceipts': '确认收货',
    'Location': '所在地区',
    'address': '地址',
    'phone': '手机',
    'fixedtelephone': '固定电话',
    'E-mail': '电子邮箱',
    'name': '姓名',
    'IDnumber': '身份证号',
    'Setasdefault': '设为默认',
    'Receivingaddress': '收货地址',
    'Receivingregion': '收件地区',
    'Touristinformation': '游客信息',
    'addTouristinformation': '添加游客信息',
    'Favoritestore': '收藏的店铺',
    'Favoriteitems': '收藏的商品',
    'Enterthestore': '进入店铺',
    'Productdetails': '商品详情',
    'after-saleservice': '售后服务',
    'contactinformation': '联系方式',
    'Mywallet': '我的钱包',
    'Walletlog': '钱包日志',
    'Mychange': '我的零钱',
    'Recharge': '充值',
    'Withdrawal': '提现',
    'Norechargerecordtemporarily': '暂无充值记录',
    'TourguideCenter': '导游中心',
    'Restrecord': '休息记录',
    'Attendancemanagement': '考勤管理',
    'Nameoftourguide': '导游名称',
    'Personalsignature': '个性签名',
    'Totalorderquantity': '总订单量',
    'Totaltransactionamount': '总交易金额',
    'Amounttobesettled': '待结算金额',
    'Tourguideorderlist': '导游订单列表',
    'Notourguideorderyet': '暂无导游订单',
    'Orderamount': '订单金额',
    'Checkorderornot': '是否验单',
    'Unverifiedorder': '未验单',
    'Checkedlist': '已验单',
    'Tourguidesettlementlist': '导游结算列表',
    'notourguide': '暂无导游结算单',
    'SettlementNo': '结算单号',
    'Settlementperiod': '结算周期',
    'Settlementamount': '结算金额',
    'Settlementstatus': '结算状态',
    'Settlementdetails': '结算明细',
    'noproblem': '没有问题',
    'somethingthematter': '有问题',
    'Confirmreceipt': '确认收款',
    'Mycoupons': '我的优惠券',
    'termofvalidity': '有效期',
    'Touse': '去使用',
    'whole': '全部',
    'Received': '已领取',
    'Couponsavailable': '可使用优惠券',
    'full': '满',
    'Used': '已使用',
    'nocoupons': '暂无优惠券,赶快去领取吧',
  }, 'shopCar': {
    'personal': '暂无',
    'allProducts': '全部商品',
    'noShopCar': '您的购物车没有商品，请先添加商品到购物车再点击购买',
    'productName': '商品名称',
    'productPicture': '商品图片',
    'specification': '规格',
    'unitPrice': '单价',
    'number': '数量',
    'totalPrice': '总价',
    'operation': '操作',
    'batchDelete': '批量删除',
    'settleAccount': '结算',
    'delete': '确定删除该商品吗?',
    'deleteYes': '确定',
    'deleteNo': '取消',
    'selectDelete': '请选择要删除的商品',
    'panel': '板块',
    'classification': '分类',
    'exist': '抱歉，搜索内容不存在',
  }, 'product': {
    'one': '商品列表',
    'two': '该商家暂无商品出售，改天再来看看吧~',
    'three': '立即购买',
    'favorite': '收藏商品',
    'collected': '已收藏',
    'price': '价格',
    'quantity': '数量',
    'stock': '库存',
    'jian': '件',
    'addCar': '加入购物车',
    'details': '商品详情',
    'evaluation': '累计评价',
    'Q&A': '商品问答',
    'name': '公司名称',
    'address': '所在地',
    'lianxi': '联系客服',
    'merchant': '进入店铺',
    'scdp': '收藏店铺',
    'evaluationList': '该商品暂无评价'
  }, 'operate': {
    'see': '查看更多',
    'address': '地址',
    'qualifications': '商家资质',
    'xing': '星',
    'sold': '已售',
    'praise': '好评',
    'begin': '起',
    'Money': '￥'
  }, 'footer': {
    'one': '品类齐全，轻松购物',
    'two': '多仓直发，极速配送',
    'three': '正品行货，精致服务',
    'four': '天天低价，畅选无忧',
    'five': '合作伙伴',
    'six': '过来玩多机位直播',
    'seven': '北京平谷区智慧旅游',
    'eight': '国际饭店',
    'nine': '花乡果巷景区',
    'ten': '合作伙伴',
    'eleven': '金融街•汤泉宫温泉旅游度假村',
    'twelve': '任记农产品•非物质文化遗产',
    'Thirteen': '万佛园4A级景区智慧导览',
    'fourteen': '兴隆山景区',
    'fifteen': '©遵化市博客旅游集散中心有限公司（guolaiwan.net）营业执照',
    'sixteen': '冀ICP备 15016998号-1',
    'seventeen': '对外贸易备案号 02610802',
    'eighteen': '违法和不良信息举报电话：4006561155',
    'nineteen': '消费者维权热线：4006067733',
    'twenty': '点击验照'
  }, 'pay': {
    'address': '选择收货地址',
    'payment': '支付方式',
    'confirm': '确认订单信息',
    'one': '商品',
    'tow': '商品属性',
    'three': '单价',
    'four': '数量',
    'five': '小计',
    'six': '确认付款',
    'seven': '收货人',
    'Managereceivingaddress': '管理收货地址',
    'eight': '默认地址'
  }, 'qrcode': {
    'one': '扫码支付',
    'two': '总价格',
    'three': '优惠金额',
    'four': '实际支付',
    'five': '请在十分钟之内完成支付，否则订单自动取消',
    'six': '取消'
  }, // 新
  'navItems': {
    "home": "首页",
    "aboutUs": "关于我们",
    "products": "项目展示",
    "companyCulture": "公司文化",
    "sustainableDevelopment": "公司发展",
    "joinUs": "加入我们"
  },
  'bannerItems': {
    'bannerContent1': '河北遵化旅游集散中心',
    'bannerContent2': '游客休憩区',
    'bannerContent3': '智能服务体验区',
    'bannerContent4': '智能体验人工服务区'
  },
  'downlist': {
    'label1': '公司概况',
    'label2': '企业荣誉',
    'label3': '新闻中心',
    'label4': '天方圆',
    'label5': '亚滦湾',
    'label6': '企业生鲜',
    'label7': '个人生鲜',
    'label8': '微官网',
    'label9': '诚采云仓',
    'label10': '招聘信息',
    'label11': '联系我们'
  },
  'projectlist': {
    'name1': '企业客户',
    'name2': '专业团队',
    'name3': '服务客户',
    'name4': '行业经验',
    'title1': '项目展示',
    'projectTitle': '我们始终为客户提供质量好、服务优、成本低的产品和服务',
    'projectContent': '我们的项目以创新为前提，整合了包含设计、技术研发、功能测试等服务在内的全栈式解决方案，为客户提供定制化的产品和服务。'
  },
  'news': {
    'title': '新闻中心',
    'dynamicTitle': '过来玩动态资讯',
    'items1': '河北省政协党组织成员、唐山市委书记张古江在唐山商务大数据中心现场考察指导工作',
    'items2': '河北省商务厅厅长徐彦平、副市长张月仙、商务局局长张雪梅在唐山电商大数据中心指导工作',
    'items3': '唐山市市长田国良在唐山商务大数据中心调研指导工作',
    'items4': '唐山市各县商务局领导在唐山商务大数据中心指导工作',
  },
  'ContactUs': {
    'title': '加入我们',
    'content1': '找工作来这里',
    'content2': '过来玩团队等待您的加入',
    'content3': '查看详情',
    'content4': '联系电话',
    'content5': '0315-6686299/0315-6681288 ',
    'content6': '邮箱',
    'content7': 'guolaiwan99@163.com',
    'content8': '地址',
    'content9': '中国·万乘晟象大厦'
  },
  'aboutUs': {
    'title': '公司概况',
    'content1': '遵化市博客旅游集散中心有限公司成立于2012年6月，注册资金1000万元。',
    'content2': '公司拥有来自全国各地资深专家、技术人才30多人，能够熟练掌握和运用物联网、云计算、大数据、A1、直播、人工智能等技术手段，独立研发自有管理系统和服务平台，通过自身的技术资源、营销系统、创新理念，助力中小企业数字化转型。',
    'content3': '具有企业注册商标1项，获得国家实用新型专利证书2项，计算机软件著作权证书10项。',
    'title1': '主要项目',
    'content4': '天方圆、亚滦湾、企业生鲜、个人生鲜、微官网、诚采云仓等',
    'content5': '我们的主要项目!助力专业实力',
    'title2': '公司荣誉',
    'content6': '我们的成就与认可，见证专业实大。',
    'title3': '新闻中心',
    'name1': '河北省政协党组织成员、唐山市委书记张古江在唐山商务大数据中心现场考察指导工作',
    'name2': '河北省商务厅厅长徐彦平、副市长张月仙、商务局局长张雪梅在唐山电商大数据中心指导工作',
    'name3': '唐山市市长田国良在唐山商务大数据中心调研指导工作',
    'name4': '唐山市各县商务局领导在唐山商务大数据中心指导工作',
    'name5': '唐山市贸促会夏会长在唐山商务大数据中心指导工作',
    'name6': '迁西县委书记李贵富在唐山商务大数据中心指导工作',
    'name7': '河北省文旅厅长翟玉虎在遵化博客旅游集散中心指导工作',
    'name8': '旅游规划首席专家、旅游品质促进会会长邸明慧在遵化博客旅游集散中心指导工作',
    'name9': '遵化市市委书记董学忠在遵化博客旅游集散中心指导工作',
    'name10': '本地旅行社相关企业负责人在遵化博客旅游集散中心参观学习',
  },
  'project': {
    'title1': '天方圆',
    'name1': '首页',
    'name2': '农产品',
    'name3': '购物车',
    'name4': '我的',
    'content1': '天方圆“绿色食品”果品远销加拿大香港等地，2016年注册商标“娘娘贡”品牌，香白杏2018和2019连续两年参加北京国际博览会，深受国内外消费者的热捧。',
    'title2': '亚滦湾',
    'name5': '首页',
    'name6': '分类',
    'name7': '购物车',
    'name8': '个人中心',
    'content2': '为用户提供一个完善的会员管理和需求提交平台，支持会员充值、优惠券管理、各业态联动等功能。',
    'title3': '企业生鲜',
    'name9': '首页',
    'name10': '分类',
    'name11': '购物车',
    'name12': '个人中心',
    'content3': '全力推进乡村全面振兴，实现让农产品上行，让工业品下行，以改善当地商品供给渠道，促进县域商业体系建设。',
    'title4': '个人生鲜',
    'name13': '首页',
    'name14': '附近',
    'name15': '分类',
    'name16': '购物车',
    'name17': '个人中心',
    'content4': '为B端生产厂家、供应商和C端经销商、消费者打造的集进、销、存管理系统为一体的移动互联网商务销售平台。',
    'title5': '诚采云仓',
    'name18': '驾驶员端',
    'name19': '学校端',
    'name20': '供应商端',
    'name21': '家长端',
    'content5': '以“公益性、透明化、智能化”为原则，建立“源头可控、过程可溯、质量可靠”的食堂管理体系，实现食品安全零事故、营养搭配科学化、运营管理规范化。',
    'title6': '微官网',
    'name22': '首页',
    'name23': '直播',
    'name24': '购物车',
    'name25': '用户中心',
    'content6': '智慧化服务平台，该平台为公司自主研发，专门为中小企业和个人打造的一款互联网商务销售平台。',
  },
  'development': {
    'title': '公司发展',
    'content1': '致力于用技术服务社会。',
    'content2': '过来玩，智慧化服务平台',
    'title1': '发展历程',
    'content3': '遵化市博客旅游集散中心发展历程。',
    'subtitle': '早期历程',
    'text1': '2012年6月 公司成立,2016年 完成全域智慧化服务平台的研发,同年，微官网、过来玩生鲜小程序、后台管理系统陆续上线。',
    'subtitle2': '发展中期',
    'text2': '2020年 成立遵化市游客服务中心,通过“互联网+物联网+旅游”的形式，为游客提供智慧旅游服务，实现本地特色产品的网络销售，打造“一县一特色”。',
    'text3': '2023年3月 自建生鲜冷库,按照国家标准设计，选用一流品牌的制冷设备、保温材料及信息化管理系统，自筹资金600万元，建成贮藏量6000吨、容量6944m³。',
    'subtitle4': '2024年至今',
    'text4': '物联网、云计算、大数据应用，平台不断迭代升级，服务器逐步扩容，陆续完成与农行资金清算系统、DeepSeek接入。',
    'subtitle5': '公司介绍',
    'text5': '遵化市博客旅游集散中心有限公司成立于2012年6月，注册资金1000万元，法定代表人刘建江 ，注册地点遵化市文礼西街引滦家属院，主要经营范围为旅游景区管理、规划设计服务；网络信息服务；销售及网上销售；互联网信息服务等。目前服务场地面积为993.27 平方米，全部为自有，平台网址为http://www.guolaiwan.net，备案号冀ICP备15016998号，具有企业注册商标1项，获得国家实用新型专利证书2项，计算机软件著作权证书10项。',
    'subtitle6': '创始人介绍',
    'text6': '创始人刘建江，现年58岁，中共党员，河北遵化人，毕业于中央党校法律系，曾先后在天津引滦和唐山交运集团第五分公司就职，2002年先后担任遵化市宏宇物业服务有限责任公司、遵化市博客旅游集散中心有限公司、泰和数潮（唐山）科技有限公司董事长，作为独资人，出资1000万元，出资比例100%。',
    'subtitle7': '荣誉资质',
    'text7': '公司为总经理负责制，下设综合办公室、销售部、财务部、物流配送团队和技术服务团队。秉承“优质服务，客户至上”的宗旨，不断提升自身实力和品牌形象，多年来荣获一系列荣誉和资质，得到了客户和社会各界的高度认可和信任。',
    'title3': '战略发展',
    'subtitle8': '发展方向',
    'text8': '坚持党的领导，以当地经济发展为己任，助力推动县域商业体系建设，强化安全意识，完善制度建设，提升监管水平，不断提高创新能力和服务意识，不断丰富平台功能和技术手段，不断适应和满足客户的需求，推动平台高质量发展。',
    'subtitle9': '发展战略',
    'text9': '1.以“020+社区配送”的成熟运营模式，逐步向外复制和延展，陆续在全国范围内布局区域中心仓、城市中转仓、配送前置仓、共享合作仓，最终实现向全国发展的目标；2.充分发挥“诚采云仓”供应链数字化平台运营模式和资金二次清算的结算模式，逐步向全市教育系统推广应用。同时，加强与餐饮行业协会合作，创新平台应用，满足餐饮行业集中招标采购、在线下单支付、自动清算资金的需求；3.以本地客户资源为核心，以公众号、小程序、APP和后台管理系统为重点，以成功典型的场景应用为突破口，充分利用技术优势，加大技术输出能力，扩大产品研发成果，加快自有平台推广，满足客户定制需求。',
    'subtitle10': '发展目标',
    'text10': '在未来5年的业务发展中，发挥自身优势，深耕服务市场，细分行业资源，与时俱进，争取“三大提升”，即平台运营能力、技术创新能力和营销服务能力的提升，同时实现“四大突破”，即平台交易总量突破20亿元、订单总量达到1000万笔、用户规模达到50万户、商户总量达到2000户。',
    'subtitle11': '成果展示',
    'name': '三地直播',
    'text11': '2023年4月6日成功承办了由遵化市委、市政府主办的中国•遵化杏花节暨“山水遵化 乐享果香”古树集中竞拍认养活动,并提供了三地互动、互联切换的直播技术支持。',
    'name2': '大数据应用',
    'text12': '2024年2月，圆满完成遵化市智慧农业示范区项目的架构搭建、设备采购、技术开发和专家验收等工作，主要是通过对种鸡、鸡舍、设备、疫苗接种等信息的智慧化采集、存储、处理以及可视化大数据分析，实时掌握相关数据，从而进一步提升智慧化管理水平，实现科学管理、健康养殖、节能降耗的目的。',
  },
  // 新的页脚
  'newFooter': {
    'PrivacyPolicy':'隐私政策',
    'text1': '增值电信业务经营许可证',
    'text2': '冀公网安备',
    'text3': '发布人电话',
    'text4': '公司电话',
    'text5': '联系邮箱',
    'text6': '发布时间',
    'text7': '发布人姓名'
  },
  'Privacy':{
    'title':'《过来玩平台个人信息保护政策》',
    'content':'\n' +
      '    过来玩平台(由遵化市博客旅游集散中心有限公司运营，以下称“过来玩”为“我们”。本政策适用于过来玩产品及服务。请您务必认真阅读本政策，在确认充分了解并同意后使用我们的产品及服务。如果您/您的监护人不同意本政策的任何内容,您应该立即停止使用。\n' +
      '    \n' +
      '    本政策主要包括以下内容:\n' +
      '    \n' +
      '    1. 本政策将根据过来玩的具体业务功能，向您说明我们可能收集的个人信息范围、收集目的、收集方式。我们将严格遵循合法、正当、必要的原则，收集、使用用户信息，用户拒绝提供非必要信息或者附加功能所需信息时，仍然能够使用过来玩核心功能。\n' +
      '    \n' +
      '    2.本政策向您说明为保护用户个人信息安全，我们所采.用的安全制度及技术措施，如设立信息安全委员会、制定相应规范制度、敏感数据加密存储、加密传输、全员签署保密协议、严格控制访问权限等，来确保您的个人信息不丢失、泄露、毁损或被未经授权的访问、使用。\n' +
      '    \n' +
      '    3.本政策向您说明我们与其他第三方共享您的个人信息的情况，包括与我们关联公司共享您的个人信息的详细情况。过来玩将严格按照本政策说明的场景使用或者共享您的个人信息，如果超出本政策说明的范围，我们会再次向您告知并征得您的明示同意。\n' +
      '    \n' +
      '    4.APP需要获取用户OAID信息，以实现定位获取当前城市。\n' +
      '    \n' +
      '    您可以通过以下索引了解本政策的具体约定:\n' +
      '    \n' +
      '    1. 我们如何收集您的个人信息\n' +
      '    \n' +
      '    2.设备权限调用\n' +
      '    \n' +
      '    3.我们如何使用Cookie及同类技术\n' +
      '    \n' +
      '    4.我们如何使用您的个人信息\n' +
      '    \n' +
      '    5.我们如何保存和保护您的个人信息\n' +
      '    \n' +
      '    6. 我们如何共享、转让、公开披露您的个人信息以及所接入的第三方\n' +
      '    \n' +
      '    7. 您的用户权利\n' +
      '    \n' +
      '    8.未成年人的个人信息保护\n' +
      '    \n' +
      '    9. 个人信息保护政策更新\n' +
      '    \n' +
      '    10. 如何联系我们\n' +
      '    \n' +
      '    1. 我们如何收集您的个人信息\n' +
      '    \n' +
      '    本政策下，个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息。个人敏感信息，是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。 我们收集的个人信息包括您提供给我们的信息、您使用服务时平台记录的信息以及来自我们的合作伙伴和关联公司等其他来源的信息。我们收集的信息范围取决于您实际使.用的产品和服务功能。\n' +
      '    \n' +
      '    1.1.帮助您成为我们的用户 您使用过来玩服务前，需要在过来玩创建账号。您需要向我们提供您的手机号码，并设置您的用户密码。您还可以通过"微信登陆"方式登录过来玩平台，如果您使用“微信登陆”，我们还需要获取您在微信平台的昵称、微信号。我们以此识别您过来玩的网络身份，并为您提供服务。如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户以及提供上述信息。\n' +
      '    \n' +
      '    1.2.向您提供产品/服务\n' +
      '    \n' +
      '    1)位置信息，在您首次使用过来玩前，我们会提示您选择是否允许过来玩获取您的位置信息。获得您的允许后，我们会通过IP地址、GPS 以及能够提供相关信息的其他传感器(如会为过来玩提供附近设备、Wi-Fi接入点和基站信息)来获取您的位置信息。\n' +
      '    \n' +
      '    2)剪切板信息，在用户下单拼单产品后，允许用户通过剪切商品信息并分享的方式邀请其他用户下单。\n' +
      '    \n' +
      '    3)您在过来玩上下单商品时，您需要提供收货人姓名、手机号码并选择提货点，以便您到相应的提货点提货以及我们与您取得联系。如果您不提供上述信息，很遗憾，我们无法为您提供服务。您还可以选择是否在备注栏内输入您要给团长的信息，不输入备注信息不影响您下单商品。如果您选择在包邮商城下单商品，您需要提供收货人姓名、手机号码、收获地址、门牌号信息，我们收集这些信息是为了帮助您顺利完成交易。\n' +
      '    \n' +
      '    4)订单信息及交易状态。我们将记录您的订单信息(包括商品名称、数量、订单金额)及交易状态。我们收集上述信息是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理用户纠纷之需要。\n' +
      '    \n' +
      '    5)您在过来玩进行交易支付时，如果您使用第三方支付机构所提供的支付服务，我们将获取您的支付工具、支付金额、支付账户风险程度信息以及支付状态。我们会与第三方支付机构共享上述信息以确认您的支付指令并完成支付。\n' +
      '    \n' +
      '    6)评价信息。您在过来玩上主动对产品/服务进行评价或发布其他内容时，我们将收集您发布的信息。您进行的评价或发布的其他内容为公开内容，请注意不要披露您的个人信息。\n' +
      '    \n' +
      '    7)为了防控运营风险，保障您的账号安全，满足法律法规要求，开展数据分析、更好改善平台服务，我们会收集您的设备信息(包括设备型号、操作系统版本、设备设 置、MAC地址及IMEI、IDFA、 0AID及其他设备标识符、 SIM卡IMSI信息、SIM 卡归属地、设备环境、移动应用列表及其他软硬件特征信息)及日志信息(包括浏览记录、检索内容、点击查看记录、交易记录以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间)。\n' +
      '    \n' +
      '    1.3. 为了向您提供客服服务\n' +
      '    \n' +
      '    当您与过来玩上的客服团队联系时，我们会以通话录音及人工录入的方式记录您的通话信息、您提出的意见或建议、您提供的姓名、联系方式，以便我们处理纠纷、解决问题或向您反馈结果。\n' +
      '    \n' +
      '    1.4.为了向您提供运营活动\n' +
      '    \n' +
      '    您参加我们的运营活动时，我们可能需要收集您的姓名、照片、通讯地址、联系方式(具体信息将以页面展示和产品/服务协议形式提前告知到您并取得您的授权)。这些信息可以帮助我们对活动结果进行公示、对活动进行后续宣传、与您取得联系、向您发放礼品或转账。\n' +
      '    \n' +
      '    1.5.业务功能的更新及其他\n' +
      '    \n' +
      '    请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告、另行签署协议等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。此外，第三方主体可能通过过来玩平台向您提供服务。当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您提供信息的，建议您仔细查看第三方主体的隐私政策或协议约定。\n' +
      '    \n' +
      '    2.设备权限调用\n' +
      '    \n' +
      '    在您使用过来玩平台相关功能的过程中，我们可能会调用您的一些设备权限。您同意本政策后，相应手机权限并不会默认开启，当涉及重要或敏感的手机权限时，我们会在您使用到相应功能时，另行弹窗再次征得您的同意后开启。权限开启后，您还可以随时通过设备设置权限关闭。在您使用过来玩平台相关功能的过程中，我们可能会调用您的一些设备权限。您同意本政策后，相应手机权限并不会默认开启，当涉及重要或敏感的手机权限时，我们会在您使用到相应功能时，另行弹窗再次征得您的同意后开启。权限开启后，您还可以随时通过设备设置权限关闭。\n' +
      '    \n' +
      '    3.我们如何使用Cookie及同类技术\n' +
      '    \n' +
      '    3.1 Cookie是支持服务器端(或者脚本)在客户端上存储和检索信息的一种机制。当您使用过来玩平台产品或服务时，为使您获得更轻松安全的访问体验，我们可能会使用Cookie或同类技术来收集和存储信息，在此过程中可能会向您的设备发送一个或 多个Cookie或匿名标识符。这么做是为了收取您的信息用于了解您的偏好，进行咨询或.数据分析，改善产品服务及用户体验，或及时发现并防范安全风险，为您提供更好的服务。我们不会将Cookie用于本政策所述目的之外的任何用途，您可根据自己的偏好留存或删除Cookie。您可清除软件内保存的所有Cookie ,当您手动清除后您的相关信息即已删除。\n' +
      '    \n' +
      '    3.2我们平台上还可能包含一些电子图像(以下简称“单像素GIF文件"或"网络Beacon")，使用网络Beacon可以计算浏览网页的用户或访问某些Cookie,我们会通过网络Beacon收集您浏览网页活动的信息，例如: Internet协议(IP)地址、浏览器类型、Internet服务提供商(SP)，参考/退出页面，操作系统、日期/时间戳,和点击数据流等。\n' +
      '    \n' +
      '    4.我们如何使用您的个人信息\n' +
      '    \n' +
      '    4.1 您的个人信息会被用于“我们如何收集您的个人信息”条款明确列明的使用场景。\n' +
      '    \n' +
      '    4.2您的个人信息可能被用于以下与“个人信息的收集”条款所声称的目的具有直接或合理关联的场景:\n' +
      '    \n' +
      '    1)我们可能对用户个人信息进行去标识化处理后，以统计数据为基础设计、开发、推广全新的产品及服务。\n' +
      '    \n' +
      '    2)我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息。\n' +
      '    \n' +
      '    4.3凡是超出与“我们如何收集您的个人信息”条款声称目的具有直接或合理关联的范围使用您的个人信息，我们会再次向您告知并征得您的同意。\n' +
      '    \n' +
      '    4.4另外，根据相关法律法规及国家标准，以下情形中,我们可能会收集、使用您的相关个人信息无需征求您的授权同意:\n' +
      '    \n' +
      '    1)与国家安全、国防安全直接相关的;\n' +
      '    \n' +
      '    2)与公共安全、公共卫生、重大公共利益直接相关的;\n' +
      '    \n' +
      '    3)与犯罪侦查、起诉、审判和判决执行等直接相关的;\n' +
      '    \n' +
      '    4)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;\n' +
      '    \n' +
      '    5)所收集的个人信息是个人信息主体自行向社会公众公开的;\n' +
      '    \n' +
      '    6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道;\n' +
      '    \n' +
      '    7)根据个人信息主体要求签订和履行合同所必需的;\n' +
      '    \n' +
      '    8)用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障;\n' +
      '    \n' +
      '    9)其他法律法规等规定的情形。\n' +
      '    \n' +
      '    5.我们如何保存和保护您的个人信息\n' +
      '    \n' +
      '    5.1信息的保存\n' +
      '    \n' +
      '    1)我们收集的您的个人信息，将在中国内地存储和使用。如涉及向境外传输个人信息，我们会按照法律法规和相关监管部门的规定，向您说明个人信息出境的相关情况并征得您的同意。\n' +
      '    \n' +
      '    2)用户使用过来玩平台服务期间，我们会持续保存用户的个人信息。\n' +
      '    \n' +
      '    3)您自主删除个人信息或注销账号，我们将按照法律、法规规定的最短期限保留您的现有个人信息。在法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用，当您的个人信息超出上述保存期限，我们将会对其进行匿名化处理。\n' +
      '    \n' +
      '    a)为配合人民检察院、公安机关、国家安全机关侦查用户使用过来玩平台服务过程中产生的犯罪行为，更好保护其他用户生命财产安全，当用户自主删除个人信息或注销账号，我们将在刑法规定的犯罪追诉时效期间内，加密隔离存档用户个人信息。\n' +
      '    \n' +
      '    4)过来玩平台与您另行签署的具体的个人信息保护政.策就某类信息的保存期限做特殊约定的，从其约定。\n' +
      '    \n' +
      '    5.2信息的保护\n' +
      '    \n' +
      '    1)我们将采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不丢失、泄露、毁损或被未经授权的访问、使用。\n' +
      '    \n' +
      '    2)过来玩平台采取以下安全技术措施保护您的个人信息:\n' +
      '    \n' +
      '    a)用户个人敏感信息被加密储存在服务器中，并通过数.据隔离技术进行存储。\n' +
      '    \n' +
      '    b)数据传输过程中使用加密传输协议。\n' +
      '    \n' +
      '    c)严格控制数据访问权限，设立完善的敏感数据访问权限申请、审批制度。\n' +
      '    \n' +
      '    d)建立数据安全监控和审计制度，进行全面数据安全控制。\n' +
      '    \n' +
      '    3)过来玩平台同时采取其他安全措施保护您的个人信息:\n' +
      '    \n' +
      '    a)建立公司信息安全委员会，统一协调管理数据安全工作，并下设数据安全小组，推动各项数据安全活动。\n' +
      '    \n' +
      '    b)公司内部颁布实施数据安全管理规范，明确对用户数据(包括用户个人信息)的保护标准和要求。\n' +
      '    \n' +
      '    c)新项目、新系统上线前对数据安全(包括用户个人信息数据)进行项目风险评估。\n' +
      '    \n' +
      '    d)与全体员工及服务外包人员签署保密协议，并严格按照工作职责分配数据访问权限。\n' +
      '    \n' +
      '    e)定期开展面向公司全体员工及外包服务人员的信息安全教育及培训。\n' +
      '    \n' +
      '    5.3安全事件处置\n' +
      '    \n' +
      '    1)为应对个人信息泄露、毁损、丢失等可能出现的安全风险，我们已经在公司范围内颁布多项制度,明确了安全事故、安全漏洞的分类分级标准，以及针对上述安全事故和漏洞，内部处理流程(包括应急响应流程)和补救措施。\n' +
      '    \n' +
      '    2)尽管我们会尽力采取商业可行的方式来保护您的个人信息，但我们不能保证其绝对安全。如若我们控制下的任何个人信息因发生安全事件而被泄露，我们将根据适用法律法规，通知个人信息可能被泄露的数据主体。当难以逐一告知用户时我们将通过发布平台公告的方式发布警示信息。\n' +
      '    \n' +
      '    5.4停止运营\n' +
      '    \n' +
      '    1)如过来玩平台停止运营，我们将至少提前30日在过来玩平台发布公告，并及时停止收集个人信息。\n' +
      '    \n' +
      '    2)停止运营后，我们将停止对个人信息的商业化使用,并在满足法律法规规定的最短保存期后，对收集的个人信息进行匿名化处理。停止运营且无承接方的，我们将对收集的个人信息进行删除处理。2)停止运营后，我们将停止对个人信息的商业化使用,并在满足法律法规规定的最短保存期后，对收集的个人信息进行匿名化处理。停止运营且无承接方的，我们将对收集的个人信息进行删除处理。\n' +
      '    \n' +
      '    6.我们如何共享、转让、公开披露您的个人信息以及所接入的第三方\n' +
      '    \n' +
      '    6.1共享是指过来玩平台向其他个人信息控制者提供个人信息，且双方分别对个人信息拥有独立控制权的过程。过来玩平台不会对外共享您的个人信息，但下列情况除外:\n' +
      '    \n' +
      '    1)在获取明确同意情况下的共享:获得您的明确同意后，我们会向您指定的第三方共享您授权范围内的信息。\n' +
      '    \n' +
      '    2)在法定情形下的共享:我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的.要求，对外共享您的个人信息。\n' +
      '    \n' +
      '    3)共享给我们的关联公司。您的信息可能会在我们的关联公司内共享:\n' +
      '    \n' +
      '    a.对于使用同一 套账号体系的业务，我们会在关联公司内共享您的账号信息包括账号、密码、昵称、头像、性别、行业、公司、职业、实名认证信息、您的位置权限设置情况;\n' +
      '    \n' +
      '    b.我们只会共享必要的个人信息，且受本政策中所声明目的的约束，如果关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。\n' +
      '    \n' +
      '    5)共享给业务合作伙伴:过来玩平台可能会向合作伙伴等第三方共享您的个人信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴包括:\n' +
      '    \n' +
      '    a. 您通过过来玩使用某些由第三方提供的服务时，我们会根据第三方的要求与其共享您的某些个人信息。我们只会基于您对使用第三方服务的确认和第三方的要求，共享您使用该服务所必需的个人信息。\n' +
      '    \n' +
      '    b. 广告、分析服务类的授权合作伙伴。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将。上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。\n' +
      '    \n' +
      '    c.如果您通过过来玩平台参加第三方举办或者过来玩平台与第三方联合举办的营销、推广活动，过来玩平台需要与第三方共享您的姓名、手机号码、收货地址或者其他必要的信息，以方便第三方统计活动参与情况、获奖情况，为您绑定您获取的优惠券、发放权益、邮寄您获取的奖品。\n' +
      '    \n' +
      '    d.供应商、服务提供商、团长或其他合作伙伴。我们可能会将您的个人信息共享给支持我们功能的第三方，包括为我们提供基础设施技术服务、自提服务、支付服务的第三方。我们共享这些信息的目的是为实现产品及服务的功能，其中可能包括您的姓名、昵称、联络信息、订单信息、支付信息、地址信息，以保障为您提供的服务顺利完成。例如，在您使用我们的服务时，我们需要与团长共享您下单时填写的收货人姓名、手机号，昵称，您购买的商品信息，以保证订单的完成;又如我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付。\n' +
      '    \n' +
      '    e. 我们会与共享个人信息的公司、组织和个人签署严格的保密协议，要求他们严格按照本政策声明的目的使用个人信息以及采取相关的保密和安全措施来处理个人信息。为维护用户或其他相关方合法权益，在协助处理与您有关的交易纠纷或争议时，我们可能向您的交易相对方或存在利害关系的第三方提供解决交易纠纷或争议所必需的信息。\n' +
      '    \n' +
      '    6.2我们将遵守相关法律法规，对您的个人信息予以保密。除非事先获得您的明确同意或授权，或依照法律规定所必须，或为了保护其他相关方重大合法权益且对个人信息进行去标识化处理的，我们不会公开披露您的个人信息。\n' +
      '    \n' +
      '    6.3另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意:\n' +
      '    \n' +
      '    1)与国家安全、国防安全直接相关的;\n' +
      '    \n' +
      '    2)与公共安全、公共卫生、重大公共利益直接相关的;\n' +
      '    \n' +
      '    3)与犯罪侦查、起诉、审判和判决执行等直接相关的;\n' +
      '    \n' +
      '    4)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;\n' +
      '    \n' +
      '    5)个人信息主体自行向社会公众公开的个人信息;\n' +
      '    \n' +
      '    6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。\n' +
      '    \n' +
      '    6.4如发生收购、兼并、重组等变更，我们会要求变更后的主体依然遵守本政策约定，履行原有义务，承担原有责任。如变更后的主体需变更个人信息使用目的，我们会要求其事先获得您的明示同意。对内而言，在之前的收购、兼并活动中，对于被收购、被兼并对象管理的数据(包括用户数据)均采用与过来玩平台自有数据相同的标准和要求进行处理和保护。\n' +
      '    \n' +
      '    6.5我们所接入的第三方软件开发工具包(SDK) 为保障过来玩相关功能的实现与应用的稳定运行, 我们可能会接入由第三方提供的软件开发包(SDK) 以实现相关目的。关于第三方如何收集、使用您的个人信息，建议您参考第三方SDK的相关服务协议及个人信息保护政策。如果您希望进一步了解我们所接入的第三方SDK情况，请您阅读第三方SDK情况说明。\n' +
      '    \n' +
      '\n' +
      '    7.1访问权\n' +
      '    \n' +
      '    您可以通过以下方式访问个人信息:\n' +
      '    \n' +
      '    1)账号，您可以通过“我的”-左上角，访问您的昵称、头像。\n' +
      '    \n' +
      '    2)订单，您可以通过“我的"我的订单，访问您的订单信息及交易状态。\n' +
      '    \n' +
      '    3)订单评价，您可以通过“我的"我的订单待评价，访问您的订单评价情况。\n' +
      '    \n' +
      '    7.2更正权\n' +
      '    \n' +
      '    1)如您希望删除个人信息，可以联系过来玩平台上的客服团队，提交删除申请。在满足法律法规要求的最短保存期限要求的情况下，我们将对您的个人信息进行删除或匿名化处理。在.上述法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。\n' +
      '    \n' +
      '    2)但当过来玩平台存在以下情形时，您删除个人信息的申请将不受法律法规要求的最短保存期限限制:\n' +
      '    \n' +
      '    a)过来玩平台违反法律、行政法规的规定收集、使用您的个人信息。\n' +
      '    \n' +
      '    b)过来玩平台违反我们双方的约定收集、使用您的个人信息。\n' +
      '    \n' +
      '    7.4撤回同意\n' +
      '    \n' +
      '    我们将通过以下方式保障用户撤回同意的权利:\n' +
      '    \n' +
      '    1)过来玩平台发送的营销短信、商业广告信息中，会向您说明具体退订方式，您可以按照信息中说明的退订方式撤回同意。\n' +
      '    \n' +
      '    2)您可以通过设备的设置功能，关闭相应设备权限，撤回对过来玩平台获取您个人信息的授权。当您撤回同意或授权后，可能导致我们无法为您继续提供撤回授权部分对应的服务。但您撤回同意或授权,不影响撤回前基于您的同意开展的个人信息处理。\n' +
      '    \n' +
      '    7.5注销账号\n' +
      '    \n' +
      '    您可以通过联系客服团队的方式注销在过来玩平台的账号。除法律法规另有规定外，注销账号之后我们将停止为您提供服务，并根据本协议约定期限保存您的个人信息，保存期限届满后我们将对您的个人信息进行匿名化处理。\n' +
      '    \n' +
      '    7.6联系客服团队\n' +
      '    \n' +
      '    如您无法通过上述方式访问、更正、删除个人信息，撤回同意或注销账号，您可以电话与过来玩平台.上的客服团队取得联系。过来玩平台上的客服团队可能需要验证您.的身份，并在验证您的身份后15日内作出答复或合理解释。\n' +
      '    \n' +
      '    8.未成年人的个人信息保护\n' +
      '    \n' +
      '    8.1我们非常重视对未成年人信息的保护。如果您是未满18周岁的未成年人，您或您的监护人需要仔细阅读本政策，并同意依照本政策使用我们的服务。如果您是未满14周岁的未成年人(以下称"儿童")，您的监护人需要仔细阅读本政策并同意您依照本政策使用。\n' +
      '    \n' +
      '    8.2如果您/您的监护人不同意本政策的任何内容，您应该立即停止使用。\n' +
      '    \n' +
      '    8.3我们指定了专人负责儿童个人信息的保护。您应当理解，当且仅当我们通过您提交的信息或者您的声明或陈 述，判断您为) l童用户时，我们通过您账号收集的个人信息才被视为儿童个人信息。\n' +
      '    \n' +
      '    8.4我们将按照本政策的约定处理儿童个人信息，当本政策约定的处理目的、方式、范围，存储事项，安全保障措施等发生了实质性变化，我们将再次征得监护人的同意。\n' +
      '    \n' +
      '    8.5儿童个人信息的收集、使用。我们收集、使用儿童个人信息的目的、方式与范围，不会超过我们在本政策中列明的内容。如果我们发现在未事先获得可证实的监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关信息。\n' +
      '    \n' +
      '    8.6儿童个人信息的共享、转让、公开披露。一般情况下，我们不会向第三方共享、转让、公开披露儿童的个人信息。我们仅在监护人同意的情况下，才可能与第三方共享、转移、披露儿童的个人信息。如需向第三方共享、转让儿童个人信息，我们将自行或者委托第三方机构进行安全评估。\n' +
      '    \n' +
      '    8.7儿童个人信息的委托处理。一般我们不会委托第三方 处理儿童个人信息，如确需委托第三方处理的，我们都会根据法律、行政法规的规定进行合规措施，包括但不限于对第三方进行安全评估。\n' +
      '    \n' +
      '    8.8儿童个人信息的存储。我们会按照本政策的约定存储儿童个人信息。\n' +
      '    \n' +
      '    8.9儿童个人信息的更正、删除。\n' +
      '    \n' +
      '    8.9.1监护人或者儿童本人可以按照本政策提供的方式更正、删除个人信息。\n' +
      '    \n' +
      '    8.9.2如果儿童或其监护人发现我们违反法律、行政法规.的规定或者本政策处理儿童个人信息，或者儿童监护人撤回同意，儿童或者其监护人或通过注销等方式终止使用服 务的，可以联系我们对相关) l童个人信息进行删除。\n' +
      '    \n' +
      '    8.10儿童个人信息的内部管理。我们对工作人员以最小授权为原则，严格设定了信息访问权限，控制儿童个人信息知悉范围。工作人员访问儿童个人信息需经过审批，我们采取了技术措施记录访问情况，避免违法复制、下载儿童个人信息。\n' +
      '    \n' +
      '    8.11儿童个人信息的安全事件应急处置和报告。\n' +
      '    \n' +
      '    8.11.1我们发现儿童个人信息发生或者可能发生泄露、毁损、丢失的，将立即启动应急预案，采取补救措施。\n' +
      '    \n' +
      '    8.11.2一旦发生安全事件，我们将及时向儿童监护人告知:安全事件的内容和影响;我们已采取或将要采取的处置措施;关于儿童或其监护人自主防范和降低风险的建议;我们针对儿童个人信息主体提供的补救措施。\n' +
      '    \n' +
      '    8.11.3如果我们判断儿童信息安全事件已经造成或者可能造成严重后果，我们将立即向有关主管部门]报告。\n' +
      '    \n' +
      '    9.个人信息保护政策更新\n' +
      '    \n' +
      '    9.1如过来玩平台发生以下变化，我们会及时对本政策.进行相应的修订:\n' +
      '    \n' +
      '    1)我们的基本情况发生变化，例如:兼并、收购、重组引起的所有者变更。\n' +
      '    \n' +
      '    2)收集、保存、使用、共享、公开披露个人信息的范围、目的、规则发生重大变化。\n' +
      '    \n' +
      '    3)您访问和管理个人信息的方式发生重大变化。\n' +
      '    \n' +
      '    4)我们的联络方式、投诉的渠道和机制发生重大变化。\n' +
      '    \n' +
      '    5)其他可能对用户个人信息权益产生重大影响的变化。\n' +
      '    \n' +
      '    9.2我们将以App推送通知、发送邮件/短信息、平台公示等方式来通知相关政策更新，以便用户及时了解最新版本的政策。同时，我们建议您定期查阅我们的政策，以及时了解更新状况。如果您在本政策更新后继续使用过来玩平台服务，即表示您已充分阅读、理解并接受更新后的政策，并愿意受更新后的政策约束。\n' +
      '    \n' +
      '    10.如何联系我们\n' +
      '    \n' +
      '    10.1您可以通过手机客户端的“客服”功能在线或者电话与我们的客服团队取得联系，反馈您的意见或投诉。\n' +
      '    \n' +
      '    10.2如果您对我们的政策或做法有任何问题或疑虑，请通过以下邮箱地址联系我们的个人信息保护负责人，我们将在15天内核实并处理您反馈的问题。\n' +
      '    \n' +
      '    10.3如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。\n' +
      '    \n' +
      '    《用户服务协议》\n' +
      '    1. 特别提示\n' +
      '    \n' +
      '    1.1本协议为过来玩平台的所有用户(以 下简称“用户")与过来玩平台所有者之间所订立的协议，本协议构成对双方有约束力的法律文件。在用户使用过来玩平台服务前，请务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款(特别是以加粗方式提示用户注意的条款)。\n' +
      '    \n' +
      '    1.2用户在进行注册过程中点击“同意”按钮(或实际使用过来玩平台服务)即表示用户完全接受本服务协议及过来玩平台的各项规则、规范。如用户对本服务协议或协议的任何部分存有任何异议，应终止注册程序(或停止使用过来玩平台服务)。\n' +
      '    \n' +
      '    1.3用户应妥善保管过来玩平台账号及密码。\n' +
      '    \n' +
      '    1.4定义\n' +
      '    \n' +
      '    1. 4.1过来玩运营方:指过来玩平台的经营者，即遵化市博客旅游集散中心有限责任公司。\n' +
      '    \n' +
      '    1.4.2过来玩平台/平台:指过来玩运营方所经营的向商户、门店和消费者提供网络交易支持综合技术服务的互联网平台，包括但不限于过来玩网站、客户端、微信小程序、微信链接等在内的各种形态。\n' +
      '    \n' +
      '    1.4.3过来玩商户/商户:指按照过来玩平台规定的程序和要求，具有资质并入驻平台的经营主体。商户通过过来玩平台以自身名义向消费者销售商品和服务。\n' +
      '    \n' +
      '    1.4.4门店:指与过来玩运营方建立合作关系的具备经营场所、配备相应设施的公司、合伙企业、个体工商户等。门店为商户提供商品存储和保管的场所和设备，办理消费者自提手续、协助商户为消费者提供商品的售后服务。\n' +
      '    \n' +
      '    1.4.5消费者:指通过过来玩平台向商户购买商品或服务的个人客户，但以下情形除外: 1)以企业名义(以发票主体判断)购买的用户; 2)以转售为目的，使用刷单软件多次下单重复购买、抢购商品的用户; 3超过正常合理消费需求的用户。\n' +
      '    \n' +
      '    1.4.6平台服务:是指过来玩平台向商户、门店、消费者提供的互联网信息发布、商业推广、商品交易、物流配送及与此有关的互联网技术服务。\n' +
      '    \n' +
      '    1.5用户\n' +
      '    \n' +
      '    1.5.1凡认可过来玩平台注册条款，具备完全民事权利能力和行为能力的自然人、法人或其他组织均可成为过来玩平台会员。\n' +
      '    \n' +
      '    1. 5.2不具备前述与用户行为相适应的民事行为能力的人，应在其监护人知悉并同意的情况下注册、使用平台服务。\n' +
      '    \n' +
      '    2.注册\n' +
      '    \n' +
      '    2.1用户同意根据注册页面的要求提供手机号码并通过认证程序注册平台账号，或通过微信授权快速注册账号。用户应保证用户对账户注册使用的手机号码或微信账户具有合法使用权。\n' +
      '    \n' +
      '    2.2用户在注册时应提供真实、准确、即时、完整的个人信息，包括但不限于用户的姓名或名称、联系地址、联系电话、电子邮箱地址等资料。用户应务必妥善保管会员账户和密码。\n' +
      '    \n' +
      '    2.3用户同意过来玩平台及关联公司可以通过各种形式,向用户发送订单信息、促销信息、活动信息、服务信息、规则变更通知等信息，以便用户及时掌握购物、消费及商品信息，享受更好的服务。\n' +
      '    \n' +
      '    2.4过来玩平台只允许每位用户使用一个过来玩平台账户。如有证据证明或平台根据规则判断用户存在不当注册或不当使用多个过来玩平台账户的情形，平台可以采取冻结、关闭账户、取消订单、拒绝提供服务等措施，如因此给平台及相关方造成损失的，用户还应承担赔偿责任。\n' +
      '    \n' +
      '    3.使用注意事项(请务必仔细阅读以下条款)\n' +
      '    \n' +
      '    3.1过来玩平台仅为商户和消费者提供交易平台服务及其他交易辅助服务，商户通过本平台向消费者销售商品或服务,消费者通过本平台下单并前往指定门店自提所订购的商品，商户为商品货物销售方,消费者为商品货物购买方，门店为商户和消费者提供宣传推广、商品代保管、代为售后维护等服务。消费者从过来玩运营方指定门店自提商品前，商品的所有权属于商户，消费者提取商品后,商品所有权归属于消费者。商户负责向用户开具商品销售发票。\n' +
      '    \n' +
      '    3.2通过本平台下单，用户应具备购买相关商品的权利能力和行为能力，如果消费者在18周岁以下，需要在监护人的监护参与下才能注册并使用本平台。在用户下订单的同时，即视为满足上述条件，并对其在订单中提供的所有信息的真实性负责。\n' +
      '    \n' +
      '    3.3下单时，请用户仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人或服务的内容、时间、限制性要求，并仔细核实用户的提货门店、提货人、电话等信息，确保由用户本人或指定人提货。用户指定他人收货的，收货人的行为和意思表示视为用户的行为和意思表示，用户对收货人的行为及意思表示的法律后果承担连带责任。\n' +
      '    \n' +
      '    3.4过来玩平台售卖商品的信息均由商户提供，由商户负责其真实性、准确性和合法性，如用户发现商品信息存在错误的或有疑问的，请告知平台客服人员。\n' +
      '    \n' +
      '    3.5用户理解并同意:本平台上供货商展示的商品和价格等信息仅仅是要约邀请，消费者下单时须填写希望购买的商品数量、价款及支付方式、收货人、联系方式、提货地址(合同履行地点)、合同履行方式等内容;系统生成的订单信息是计算机信息系统根据消费者填写的内容自动生成的数据，仅为消费者向供货商发出的合同要约;只有在消费者成功支付货款且商品到达提货门店时，其与商户之间才就已到达提货门店的商品建立了合同关系。\n' +
      '    \n' +
      '    3.6用户理解并同意，尽管商户做出最大的努力，但由于市场变化及各种以合理商业努力难以控制因素的影响，在特殊情况下，消费者付款之后也会存在库存不足、以及配送运力不足以及不可抗力等导致的履约不能的可能;如遇上述情况，过来玩平台或提货门店将及时与用户联系，用户有权取消订单，商户亦有权自行取消订单，如用户已付款，平台将会为用户办理退款手续。\n' +
      '    \n' +
      '    3.7用户理解并同意，商户销售的商品如存在任何质量问题，由商户负责更换、维修、退货等相关售后工作，并承担相应责任，过来玩运营方及门店会合理地尽力代为沟通协调，并协助用户追究商户的责任。\n' +
      '    \n' +
      '    3.8用户理解并同意，其在过来玩平台上的交易应以最终消费者而非以转销售为目的。如用户以转售等商业目的购买商品，平台和商户有权拒绝出售、取消交易、取消促销价格和优惠政策，并要求用户依据本协议的约定承担违约责任。\n' +
      '    \n' +
      '    4.配送与提货\n' +
      '    \n' +
      '    4.1由于过来玩平台商品以生鲜类商品为主，用户应及时于指定门店自提商品，并且对商品进行验货，在配送凭证上签字确认或收取商品后即完成收货。\n' +
      '    \n' +
      '    4.2用户应准确地填写自己的提货门店、收货人及联系方式。如因以下情形导致订单延迟或无法配送的，商户无需承担相关责任，并保留单方取消订单的权利:\n' +
      '    \n' +
      '    1)提货门店、联系方式等信息错误;\n' +
      '    \n' +
      '    2)商品送达指定提货门店后的24小时内用户未自提的;\n' +
      '    \n' +
      '    3)因不可抗力导致订单延迟或无法配送的。3)因不可抗力导致订单延迟或无法配送的。\n' +
      '    \n' +
      '    4.3用户理解并同意，过来玩平台上展示商品预计到店时间、自提时间仅供参考。\n' +
      '    \n' +
      '    5.隐私保护\n' +
      '    \n' +
      '    5.1过来玩平台将保护用户隐私和其他个人信息，具体内容详见过来玩平台个人信息相关保护政策。除法律法规规定的情形外，过来玩平台不会在未经用户的许可情况下向第三方公开、透露用户的个人信息。\n' +
      '    \n' +
      '    6.用户规范\n' +
      '    \n' +
      '    6.1用户承诺在使用过来玩平台服务的过程中应遵守法律法规、公序良俗及诚实信用原则;不得侵犯过来玩及任何第三方的合法权益;不得扰乱平台的正常秩序;不得干扰过来玩网络的正常功能，危害其网络系统安全;用户亦不得实施包括但不限于以下行为:\n' +
      '    \n' +
      '    6.1.1以任何机器人软件、蜘蛛软件、爬虫、刷屏软件等非过来玩认可的方式访问或登录平台;\n' +
      '    \n' +
      '    6.1.2通过任何方式对平台造成或可能造成不合理或不合比例的重大负荷;\n' +
      '    \n' +
      '    6.1.3通过发送病毒、木马等行为攻击其他用户账号或终端设备;\n' +
      '    \n' +
      '    6.1.4下单后无正当理由拒不收货、提货;\n' +
      '    \n' +
      '    6.1.5协助他人获取不正当利益;教唆他人从事本协议所禁止的行为。\n' +
      '    \n' +
      '    6.2用户承诺，不利用在平台上注册的账号进行经营活动，牟利行为及其他未经平台许可的行为:\n' +
      '    \n' +
      '    6.2.1用户仅享有在诚信优选平台购物时对其账号内的优惠信息的使用权，不得转卖账号、积分、返利、抵用券或其他类型的优惠券、礼品卡、或利用平台账号进行其他经营性行为;\n' +
      '    \n' +
      '    6.2.2不得恶意利用技术手段或其他方式，进行1)为获取优惠、折扣或其他利益而注册多个账号、下单等行为，或2)超出正常合理需求的下单行为,或3)影响其他用户正常消费行为或相关合法权益、影响过来玩平台上正常经营秩序的行为;\n' +
      '    \n' +
      '    6.2.3不得以再销售或商业使用为目的,对平台上商户销售的商品进行购买;\n' +
      '    \n' +
      '    6.3若用户未遵守以上规定的，过来玩运营方有权判定用户的行为是否符合本协议约定以及平台规则,并视行为情节有权限制或终止向用户提供服务,取消订单、要求商户停止发货等措施，直至注销用户的账户。同时过来玩运营方保留向有关政府部门进行举报的权利，用户需承担由此而产生的全部法律责任。\n' +
      '    \n' +
      '    7.知识产权\n' +
      '    \n' +
      '    7.1过来玩运营方是过来玩平台及过来玩产品的所有权及知识产权权利人。\n' +
      '    \n' +
      '    7.2上述过来玩产品指的是过来玩平台运营方、过来玩平台运营方关联公司、或其授权主体等通过过来玩平台为用户提供的包括但不限于信息发布分享、关系链拓展、便捷辅助工具、平台应用程序、公众开放平台等功能、软件、服务等。\n' +
      '    \n' +
      '    7.3过来玩平台运营方是过来玩平台及过来玩产品中所有信息内容的所有权及知识产权权利人。前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等，除按照法律法规规定应由相关权利人享有权利的内容以外。\n' +
      '    \n' +
      '    8.违约责任\n' +
      '    \n' +
      '    8.1如因过来玩平台运营方违反有关法律、法规或本协议项下的任何条款而给用户造成损失的，因此给用户造成的损害赔偿责任由过来玩平台运营方承担。\n' +
      '    \n' +
      '    8.2用户同意保障和维护过来玩平台运营方及其关联公司及其他用户的合法权益，如因用户违反有关法律、法规或本协议项下的任何条款而给过来玩平台运营方及其关联公司或任何其他任何第三方造成损失，用户同意承担由此造成的损害赔偿责任。\n' +
      '    \n' +
      '    8.3过来玩平台发现用户有不当行为时，可以采取以下措施:\n' +
      '    \n' +
      '    8.3.1更改、删除或屏蔽相关内容;\n' +
      '    \n' +
      '    8.3.2变更、限制或禁止违规账号部分或全部功能或关闭该账号;\n' +
      '    \n' +
      '    8.3.3向有关监管部门或国家机关报告;\n' +
      '    \n' +
      '    8.3.4其他过来玩平台运营方认为合理的措施。\n' +
      '    \n' +
      '    8.4平台将在商业允许范围内尽最大努力减少错误，但平台上提供的服务和信息仍可能包含错误内容，过来玩对用户因此等原因使用平台而造成的损失不负法律责任。若用户对平台提供的部分或所有服务不满意，应立即停止使用这些服务。\n' +
      '    \n' +
      '    9.特别声明\n' +
      '    \n' +
      '    9.1不论在何种情况下，过来玩对由于信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统故障，疫情、电力故障、暴乱、骚乱、罢工、劳动争议、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。\n' +
      '    \n' +
      '    9.2作弊、扰乱交易秩序的行为\n' +
      '    \n' +
      '    9.2.1除活动规则另有规定外,每次活动中，每个用户只限参加一次活动(活动包括但不限于促销优惠、秒杀、抽奖等等)，同一用户只能中奖一次。同一手机、同一联系方式、同一IP地址、同一过来玩平台账号、同一身份证、同一付款账号、同一终端设备号或其他可以合理显示为统一用户的情形，均视同一用户。\n' +
      '    \n' +
      '    9.2.2活动期间，如发现有用户通过不正当手段参加活动而有碍其他用户公平参加活动，或有违反活动目的之行为,平台或其他活动举办方有权取消该等用户获奖资格或其因参加活动所获赠品或权益。如此种作弊和为或扰乱交易秩序的行为给平台或活动举办方造成损失的，平台或活动举办方保留追究赔偿的权利。本协议下不正当手段包括但不限于任何侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、恶意套现、刷信誉、批量注册帐号、用机器注册平台帐号、用机器模拟客户端等。\n' +
      '    \n' +
      '    9.2.3对于恶意进行注册、反复交易退款、侵害过来玩或商户实际经营交易的情况或行为，平台或商户会停止服务、封停账号并追究责任。\n' +
      '    \n' +
      '    10.协议修改\n' +
      '    \n' +
      '    10.1过来玩平台有权随时修改本协议的任何条款，一旦本协议的内容发生变动，过来玩平台运营方将会在过来玩平台上公布修改之后的协议内容，或向用户通知修改内容。如不同意上述修改的，用户有权停止使用过来玩平台服务。\n' +
      '    \n' +
      '    11.通知送达\n' +
      '    \n' +
      '    11.1本协议项下过来玩平台运营方对于用户所有的通知均可通过小程序公告、公众号、电子邮件、系统通知、账号主动联系、手机短信或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人。\n' +
      '    \n' +
      '    11.2用户通过过来玩平台运营方对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。\n' +
      '    \n' +
      '    12.争议解决\n' +
      '    \n' +
      '    12.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律\n' +
      '    \n' +
      '    12.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决;协商不成时，任何一方均可向河北省遵化市人民法院提起讼。\n' +
      '    \n' +
      '    13.其他\n' +
      '    \n' +
      '    13.1本协议于 年 月  日首次生效，并于 年 月 日最新修订生效。\n' +
      '    \n' +
      '    个人信息共享清单\n' +
      '    \n' +
      '    一、第三方SDK列表\n' +
      '    \n' +
      '    为保障过来玩相关功能的实现和应用的安全稳定运行，我们会接入由第三方提供的软件开发包（SDK）实现该目的。\n' +
      '    \n' +
      '    我们会对第三方SDK进行严格的安全检测，并要求合作伙伴采取严格的措施来保护您的个人数据。在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK，并及时在本说明中向您公开说明接入第三方SDK的最新情况。请注意，第三方SDK可能因为版本升级、策略调整等原因导致数据类型存在一些变化，附其官方网站链接或相关隐私保护说明链接供参考，具体请以其公示的官方说明为准。\n' +
      '    \n' +
      '    安卓操作系统第三方SDK列表\n' +
      '    \n' +
      '    产品/类型：支付宝\n' +
      '    \n' +
      '    使用目的：可帮助用户完成付款、提供安全认证服务\n' +
      '    \n' +
      '    收集个人信息类型：设备信息（IMSI、IMEI、MAC地址、AndroidID）、位置信息、应用列表、外部存储\n' +
      '    \n' +
      '    运营方：支付宝（中国）网络技术有限公司\n' +
      '    \n' +
      '    隐私政策链接：https://render.alipay.com/p/c/k2cx0tg8\n' +
      '    \n' +
      '    产品/类型：微信支付\n' +
      '    \n' +
      '    使用目的：用于支付、确认设备安全\n' +
      '    \n' +
      '    使用场景：使用支付功能时\n' +
      '    \n' +
      '    个人信息收集类型：个人常用设备信息、位置信息、IMSI、IMEI、经度、纬度、手机号码、设备序列号\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：深圳市腾讯计算机系统有限公司\n' +
      '    \n' +
      '    隐私保护说明： https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2\n' +
      '    \n' +
      '    产品/类型：高德地图\n' +
      '    \n' +
      '    使用目的：用于订单物流跟踪，位置展示\n' +
      '    \n' +
      '    使用场景：新建地址或者修改地址时，查看订单配送进度时\n' +
      '    \n' +
      '    个人信息收集类型：Wifi信息、位置信息、IMSI、ssid、任务列表、设备版本、MAC地址、bssid、IMEI、手机样式、经度、纬度、网络设备制造商、android_id\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：阿里巴巴集团控股有限公司\n' +
      '    \n' +
      '    隐私保护说明：https://lbs.amap.com/pages/privacy/?target=_blank\n' +
      '    \n' +
      '    产品/类型：高德定位\n' +
      '    \n' +
      '    使用目的：用于GPS定位和IP定位，如搜索附近门店、参加城市特定活动（如消费券）\n' +
      '    \n' +
      '    使用场景：用户查看所在位置附近的商品或服务时；参与所在位置有关的营销互动活动时\n' +
      '    \n' +
      '    个人信息收集类型：经纬度、IP地址、ssid、bssid、设备序列号\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：阿里巴巴集团控股有限公司\n' +
      '    \n' +
      '    隐私保护说明：https://lbs.amap.com/pages/privacy/?target=_blank\n' +
      '    \n' +
      '    产品/类型：腾讯开放平台（QQ、QQ互联）\n' +
      '    \n' +
      '    使用目的：用于快速登录、支付、互动等功能\n' +
      '    \n' +
      '    使用场景：用户进行登录时，使用QQ钱包支付时，将页面分享至QQ好友或朋友圈时\n' +
      '    \n' +
      '    个人信息收集类型：个人常用设备信息、设备识别信息\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：深圳市腾讯计算机系统有限公司\n' +
      '    \n' +
      '    隐私保护说明：https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e\n' +
      '    \n' +
      '    产品/类型：小米推送\n' +
      '    \n' +
      '    使用目的：用于消息推送\n' +
      '    \n' +
      '    使用场景：用户账号相关促销活动、消息提醒更新时\n' +
      '    \n' +
      '    个人信息收集类型：设备唯一标识码、网络状态、网络制式、设备序列号\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：小米科技有限责任公司\n' +
      '    \n' +
      '    隐私保护说明：https://dev.mi.com/console/doc/detail?pId=1822\n' +
      '    \n' +
      '    产品/类型：华为HMS-Core（华为推送、华为应用升级）\n' +
      '    \n' +
      '    使用目的：用于消息推送\n' +
      '    \n' +
      '    使用场景：用户账号相关促销活动、消息提醒更新时\n' +
      '    \n' +
      '    个人信息收集类型：设备唯一标识码、设备序列号\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：华为技术有限公司\n' +
      '    \n' +
      '    隐私保护说明：https://developer.huawei.com/consumer/cn/devservice/term/\n' +
      '    \n' +
      '    产品/类型：魅族推送\n' +
      '    \n' +
      '    使用目的：用于消息推送\n' +
      '    \n' +
      '    使用场景：用户账号相关促销活动、消息提醒更新时\n' +
      '    \n' +
      '    个人信息收集类型：当前流量卡、匿名用户ID（OAID）、IMSI、位置信息、设备序列号\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：魅族科技有限公司\n' +
      '    \n' +
      '    隐私保护说明：https://www.meizu.com/legal.html\n' +
      '    \n' +
      '    产品/类型：Vivo\n' +
      '    \n' +
      '    使用目的：用于消息推送\n' +
      '    \n' +
      '    使用场景：用户账号相关促销活动、消息提醒更新时\n' +
      '    \n' +
      '    个人信息收集类型：匿名用户ID（OAID）\n' +
      '    \n' +
      '    收集方式：SDK本机采集，不涉及数据共享\n' +
      '    \n' +
      '    第三方公司名称：维沃移动通信有限公司\n' +
      '    \n' +
      '    隐私保护说明：https://dev.vivo.com.cn/documentCenter/doc/366\n' +
      '    \n' +
      '    SDK 名称：高德地图定位SDK \n' +
      '    合作方：高德软件有限公司 \n' +
      '    合作目的：加油站导航服务，支持美团外卖优惠的定位服务 \n' +
      '    个人信息收集方式：嵌入第三方SDK，SDK收集传个人信息、设备信息 \n' +
      '    个人信息收集范围：查看WLAN连接；粗略定位；精确定位；读取外置存储卡；读取手机状态身份；写入外置存储卡；后台访问地理位置、陀螺仪传感器,加速度传感器,重力传感器 \n' +
      '    隐私政策：https://lbs.amap.com/home/agreement/data-security \n' +
      '\n',
  }
};



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js